
import Body from "./body/body";
export default function About() {
    return (
        <>
            <Body></Body>
        </>
    );
}